import convertFifteenPlaces from 'components/ProductSideBar/helpers/conversion';
import { Maths } from 'helpers/maths';

const calcUnitPrice = (totalProduct, totalCostValue) => {
  const result = Maths.divide(
    Number.parseFloat(totalCostValue),
    Number.parseFloat(totalProduct)
  );
  // Same as calcQuantityFromCost below: result is a Decimal, so the coercing
  // global isFinite is required. Number.isFinite fails its typeof check and
  // would always return false here.
  const resultIsFinite = isFinite(result); // NOSONAR
  if (resultIsFinite) {
    return convertFifteenPlaces(result);
  }
  return typeof result.toNumber === 'function' ? result.toNumber() : result;
};

export const calcQuantityFromCost = (totalCostValue, priceValue) => {
  const result = Maths.divide(
    Number.parseFloat(totalCostValue),
    Number.parseFloat(priceValue)
  );
  // result is always a Decimal instance, never a primitive number — the
  // coercing global isFinite is required here. Number.isFinite fails its
  // typeof check before any coercion, so it would always return false for
  // this value and silently skip the rounding below.
  return isFinite(result) ? convertFifteenPlaces(result) : result.toNumber(); // NOSONAR
};

export default calcUnitPrice;
